// IMPORTANT! This file should be the same across all front-end-projects, when it's updated
// we need to update it in the other portals as well

/* Attributes with a definition in iota-config */

export enum ProductAttribute {
    NAME = 'NAME',
    IMMEDIATELY_EFFECTIVE_WITHOUT_BUDGET = 'IMMEDIATELY_EFFECTIVE_WITHOUT_BUDGET',
    MANDATORY = 'MANDATORY',
    MINIMUM_TERM_PERIOD = 'MINIMUM_TERM_PERIOD',
    MINIMUM_TERM_AMOUNT = 'MINIMUM_TERM_AMOUNT',
    PRODUCT_START_DATE = 'PRODUCT_START_DATE',
    PRODUCT_AUTORENEWAL = 'PRODUCT_AUTORENEWAL',
    BUDGET_RENEWAL_PERIOD = 'BUDGET_RENEWAL_PERIOD',
    BUDGET_RENEWAL_PERIOD_AMOUNT = 'BUDGET_RENEWAL_PERIOD_AMOUNT',
    PRODUCT_CANCELLATION_DATE_INTERVAL = 'PRODUCT_CANCELLATION_DATE_INTERVAL',
    PRODUCT_CANCELLATION_DATE_START = 'PRODUCT_CANCELLATION_DATE_START',
    PRODUCT_CANCELLATION_DATE_END = 'PRODUCT_CANCELLATION_DATE_END',
    USAGE_LIMIT = 'USAGE_LIMIT',
    SORTING_PRIORITY = 'SORTING_PRIORITY',
    BIKE_LEASING_INSURANCE_PERCENTAGE_VALUE = 'BIKE_LEASING_INSURANCE_PERCENTAGE_VALUE',
    BIKE_LEASING_INTEREST_RATE = 'BIKE_LEASING_INTEREST_RATE',
    IMAGE_URL = 'IMAGE_URL',
    DESCRIPTION = 'DESCRIPTION',
    PRODUCT_AVAILABLE_FROM = 'PRODUCT_AVAILABLE_FROM',
    PRODUCT_DISCONTINUED = 'PRODUCT_DISCONTINUED',
    MINIMUM_SELECTIONS_FOR_ACTIVATION = 'MINIMUM_SELECTIONS_FOR_ACTIVATION'
}

export enum RegistrationPeriodAttribute {
    BIKE_LEASING_BIKE_PRICE_MAX_VALUE = 'BIKE_LEASING_BIKE_PRICE_MAX_VALUE',
    BIKE_LEASING_BIKE_PRICE_MIN_VALUE = 'BIKE_LEASING_BIKE_PRICE_MIN_VALUE',
    BIKE_LEASING_CAN_INVEST_NOTHING = 'BIKE_LEASING_CAN_INVEST_NOTHING',
    BIKE_LEASING_DD_CUSTOMER_PORTAL_URL = 'BIKE_LEASING_DD_CUSTOMER_PORTAL_URL',
    BIKE_LEASING_EMPLOYER_SUBSIDISED = 'BIKE_LEASING_EMPLOYER_SUBSIDISED',
    BIKE_LEASING_IS_DEFERRED_COMPENSATION = 'BIKE_LEASING_IS_DEFERRED_COMPENSATION',
    BIKE_LEASING_IS_INSURANCE_PAYED_BY_EMPLOYER = 'BIKE_LEASING_IS_INSURANCE_PAYED_BY_EMPLOYER',
    BIKE_LEASING_MUST_INVEST_EVERYTHING = 'BIKE_LEASING_MUST_INVEST_EVERYTHING',
    ALLOW_ONE_OVERBOOKING = 'ALLOW_ONE_OVERBOOKING',
    DISABLE_PAYOUT = 'DISABLE_PAYOUT',
    PREVENTION_COURSES_DISABLE_INVESTMENT = 'PREVENTION_COURSES_DISABLE_INVESTMENT',
    SHOW_EVENT_MOCK_DATA = 'SHOW_EVENT_MOCK_DATA',
    SHOW_NUTRITION_UPLOAD_MOCK_DATA = 'SHOW_NUTRITION_UPLOAD_MOCK_DATA',
    SHOW_ONLINE_COURSE_MOCK_DATA = 'SHOW_ONLINE_COURSE_MOCK_DATA',
    SHOW_QUESTIONNAIRE_MOCK_DATA = 'SHOW_QUESTIONNAIRE_MOCK_DATA',
    SHOW_UPLOAD_MOCK_DATA = 'SHOW_UPLOAD_MOCK_DATA',
    INTERNAL_NAME = 'INTERNAL_NAME',
    NAME = 'NAME',
    SUBSCRIPTION_INSTANTIATION = 'SUBSCRIPTION_INSTANTIATION',

    // Complex attributes
    BLOCKING_RULE_VACATION_WORKING_ALL_HEALTH_PRODUCTS = 'BLOCKING_RULE_VACATION_WORKING_ALL_HEALTH_PRODUCTS',
    CATEGORY_EXCLUSIONS = 'CATEGORY_EXCLUSIONS',

    // Attributes with a suffix, e.g. VACATION_WORKING_TO_VACATION_DAY_FACTOR#...
    VACATION_WORKING_TO_VACATION_DAY_FACTOR = 'VACATION_WORKING_TO_VACATION_DAY_FACTOR'
}

export enum CompanyAttribute {
    SHOW_EVENTS_ANNOUNCEMENTS = 'SHOW_EVENTS_ANNOUNCEMENTS',
    SHOW_FEEDBACK_MESSAGES = 'SHOW_FEEDBACK_MESSAGES',
    SHOW_MOCK_DATA = 'SHOW_MOCK_DATA',
    SHOW_INSIGHTS_VALUES_MOCK_DATA = 'SHOW_INSIGHTS_VALUES_MOCK_DATA',
    USER_VERIFICATION_PROCEDURE = 'USER_VERIFICATION_PROCEDURE'
}

/* These attributes have no definition in iota-config, but are copied from other objects or defined in the backend */

export enum SubscriptionAttribute {
    NAME = 'NAME',
    MANDATORY = 'MANDATORY',
    SORTING_PRIORITY = 'SORTING_PRIORITY',

    USAGE_LIMIT = 'USAGE_LIMIT',
    USABLE_BUDGET = 'USABLE_BUDGET',
    PENDING_TRANSACTION_SUM = 'PENDING_TRANSACTION_SUM',
    TRANSACTION_SUM = 'TRANSACTION_SUM'
}

export enum CaseAttribute {
    AMOUNT = 'AMOUNT',
    AMOUNT_CURRENCY = 'AMOUNT_CURRENCY',
    CATEGORY = 'CATEGORY',
    PENDING_TRANSACTION_SUM = 'PENDING_TRANSACTION_SUM',
    TRANSACTION_SUM = 'TRANSACTION_SUM',
    GKV_REIMBURSEMENT = 'GKV_REIMBURSEMENT',

    DIAGNOSIS = 'DIAGNOSIS',
    EXPORT_NOTE = 'EXPORT_NOTE',
    CLAIM_NOTE = 'CLAIM_NOTE',
    FOYER_INVOICE_NUMBER = 'FOYER_INVOICE_NUMBER',
    MAIL_SENT = 'MAIL_SENT',

    INVOICE_NUMBER = 'INVOICE_NUMBER'
}

export enum TransactionAttribute {
    AMOUNT = 'AMOUNT',
    GOODWILL_PAYMENT = 'GOODWILL_PAYMENT',
    DESCRIPTION = 'DESCRIPTION',
    CURRENCY = 'CURRENCY'
}
